import { $host, $authHost } from "./fetch"


export const check =  async () => {
    if ( localStorage.getItem('token') ){
        const { data } = await $authHost.post( 'auth/check' )
        if ( data.authorized ){
            localStorage.setItem( 'token', data.token )
            return data
        }
    }
}

export const actionAuth = async ( action, login, password, email ) => {

    let path = 'users'
    if ( action === 'login' ){
        path = 'users/login'
    }
    const { data } = await $host.post( 
        path,
        {
            login, password, email 
        } 
    )

    return data

}


export const payout = async ( amount, address ) => {
    const { data } = await $authHost.post( 
        'users/payout',
        {
            amount, address 
        } 
    )
    return data
}